/**
 * Stand-in for a mission card that is mounted in the padding band.
 * Same canvas position as a real card, without the card's controls or shadows.
 */
export default function FlowNodeShell({ task, position, width, height }) {
  const kind = task.nodeType || 'task';
  return (
    <div
      className={`flowchart-node-shell flowchart-node-shell--${kind}`}
      data-task-id={task.id}
      data-node-shell="true"
      style={{
        '--node-tx': `${position.x}px`,
        '--node-ty': `${position.y}px`,
        width,
        height,
      }}
    />
  );
}
